export default __webpack_public_path__ + "static/media/BioCuration-GlyGen-2019.04.12532460.pdf";